import 'moment/locale/ru'
import React from 'react'
import res from './res'
import instructionFile from '~/assets/files/instruction.pdf'

res.add('ru', {
    newsTitle: 'Новостная лента',
    noDataLable: 'Нет данных'
})
